import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    noSortContainer: {
        width: '15px',
        marginLeft: '5px',
        display: 'inline-block',
    },
    headerContainer: {
        '& .headerTitleContainer': {
            lineHeight: '16px',
            marginTop: '5px',
        },
        '& .headerSpacer': {
            ...theme.mixins.flex.grow(1),
        },
        '& .headerSortContainer': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            '& .headerSort': {
                color: theme.palette.text.secondary,
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '0.7em',
                cursor: 'pointer',
                userSelect: 'none',
                '& svg': {
                    verticalAlign: 'middle',
                    fontSize: '15px',
                    marginLeft: '5px',
                },
                '&.headerLeft': {
                    marginRight: '10px',
                },
                '&.headerRight': {
                    marginLeft: '10px',
                },
            },
        },
    },
}));

export default useStyles;
